import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { SolicitarAyuda } from './pages/SolicitarAyuda';
import { QuieroSerAliado } from './pages/QuieroSerAliado';
import { Donar } from './pages/Donar';
import { VenezuelaEmergencia } from './pages/VenezuelaEmergencia';
import { DonarVenezuela } from './pages/DonarVenezuela';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mmcbg18ucy8l">
      <div className="w-full min-h-screen bg-white" data-id="element-1" data-mp="2mn5bykh7iria">
        <Navbar data-id="element-2" data-mp="31aqf2ee30qq7" />
        <Routes data-id="element-3" data-mp="31b8ko1mmwhas">
          <Route path="/" element={<Home data-id="element-5" data-mp="31c9y2cr4hfvo" />} data-id="element-4" data-mp="31bs11dwmyxmp" />
          <Route path="/solicitar-ayuda" element={<SolicitarAyuda data-id="element-7" data-mp="2wjqhd6x524mn" />} data-id="element-6" data-mp="31cjnnz899l0u" />
          <Route path="/quiero-ser-aliado" element={<QuieroSerAliado data-id="element-9" data-mp="28ufoebm15ej2" />} data-id="element-8" data-mp="2wifgpfyzpczr" />
          <Route path="/donar" element={<Donar data-id="element-11" data-mp="28sl3gxardmez" />} data-id="element-10" data-mp="28te0v7ntuzkg" />
          <Route path="/venezuela-emergencia" element={<VenezuelaEmergencia data-id="element-13" data-mp="23utas12ahw9q" />} data-id="element-12" data-mp="28s2ztflro5x1" />
          <Route path="/donar-venezuela" element={<DonarVenezuela data-id="element-15" data-mp="3ij64a9st9l7v" />} data-id="element-14" data-mp="3ik7g4ghnibqn" />
        </Routes>
        <Footer data-id="element-16" data-mp="3mlj9mx3nbh44" />
      </div>
    </BrowserRouter>;
}